import type { FilterChip } from "../../types";
import type { RankingsSlice } from "./slice";

export function getChips(
  slice: RankingsSlice,
  setSlice: (slice: RankingsSlice) => void
): FilterChip[] {
  const chips: FilterChip[] = [];

  if (slice.fortune500) {
    chips.push({
      id: "rankings-fortune500",
      label: "Fortune 500",
      filterKey: "rankings",
      onRemove: () => setSlice({ ...slice, fortune500: false }),
    });
  }
  if (slice.forbes2000) {
    chips.push({
      id: "rankings-forbes2000",
      label: "Forbes Global 2000",
      filterKey: "rankings",
      onRemove: () => setSlice({ ...slice, forbes2000: false }),
    });
  }
  return chips;
}

export function getCount(slice: RankingsSlice): number {
  return Number(slice.fortune500) + Number(slice.forbes2000);
}
